import { Box, IconButton, useMediaQuery, useTheme } from "@mui/material";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import visitaxlogo from "../../../../assets/images/HomePage/VISITAX.webp";
import visitaxLogoColor from "../../../../assets/images/HomePage/VisitiaxColor.webp";
import logogob from "../../../../assets/images/HomePage/LOGO GOBIERNO.webp";
import logoGobColor from "../../../../assets/images/HomePage/SATQColor.webp";
import StyledLink from "../../../../components/basic-styled-components/StyledLink/StyledLink";
import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import { useConfigurations } from "../../../../context/ConfigurationsContext/ConfigurationsContext";
import { StyledToolbar } from "../../../../components/basic-styled-components/ToolBar/ToolBar";
import { usePrincipalPage } from "../../../../context/PrincipalPageContext/PrincipalPageContext";
import { useAuth } from "../../../../context/AuthContext/AuthContext";
import LogoutIcon from "../../../../assets/images/HomePage/Icons/log-out.svg";
import DashboardIcon from "../../../../assets/images/HomePage/Icons/layout-left.svg";
import LogoutModal from "../../../../components/composed-styled-components/LogoutModal/LogoutModal";

type ColorScheme = "dark" | "light";

const baseNavLinkStyle = {
  alignItems: "center",
  borderRadius: "8px",
  color: "#4A4A4A",
  display: "inline-flex",
  fontFamily: "Candara",
  fontSize: "14px",
  fontWeight: 600,
  height: "38px",
  justifyContent: "center",
  lineHeight: "20px",
  padding: "0 14px",
  textDecoration: "none",
  textTransform: "none" as const,
  whiteSpace: "nowrap" as const,
};

const PrincipalPageToolBar = ({
  colorScheme = "dark",
}: {
  colorScheme?: ColorScheme;
}) => {
  const configurations = useConfigurations();
  const principalpageconfigs = usePrincipalPage();
  const auth = useAuth();
  const theme = useTheme();
  const isCompactHeader = useMediaQuery(theme.breakpoints.down("lg"));
  const location = useLocation();
  const navigate = useNavigate();
  const [openLogoutModal, setOpenLogoutModal] = useState(false);
  const txt = configurations.txt[configurations.currentlenguage];
  const selectedFlag =
    configurations.flags[configurations.currentlenguage].toLowerCase();
  const isLight = colorScheme === "light";
  const navColor = isLight ? "#2B2B2B" : "#FFFFFF";
  const visitaxLogoSrc = isLight ? visitaxLogoColor : visitaxlogo;
  const gobiernoLogoSrc = isLight ? logoGobColor : logogob;
  const horizontalInset = isCompactHeader ? 20 : 67;
  const isFaq = location.pathname.startsWith("/FAQS");
  const isBlog = location.pathname.startsWith("/Blog");
  const userInitial = (
    auth.user?.name?.trim()?.charAt(0) ||
    auth.user?.userName?.trim()?.charAt(0) ||
    "K"
  ).toUpperCase();
  console.log("selectedFlag", selectedFlag)
  return (
    <StyledToolbar
      style={{
        alignItems: "center",
        backdropFilter: isLight ? "blur(4px)" : "none",
        background: isLight ? "rgba(255, 255, 255, 0.94)" : "transparent",
        borderBottom: isLight
          ? "1px solid #D9D9D9"
          : "1px solid rgba(255, 255, 255, 0.45)",
        borderRadius: 0,
        color: "#2B2B2B",
        margin: "0 auto",
        minHeight: "86px",
        padding: isCompactHeader ? "10px 6px 12px" : "16px 0",
        width: `calc(100% - ${horizontalInset * 2}px)`,
      }}
    >
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          gap: "15px",
          minWidth: isCompactHeader ? "unset" : "260px",
        }}
      >
        <StyledLink to="/" style={{ display: "inline-flex", flexShrink: 0 }}>
          <Box
            component="img"
            src={visitaxLogoSrc}
            alt="VISITAX Logo"
            loading="eager"
            decoding="async"
            sx={{
              display: "block",
              height: isCompactHeader ? "34px" : "41px",
              objectFit: "contain",
              width: isCompactHeader ? "67px" : "81px",
            }}
          />
        </StyledLink>
        <Box
          component="img"
          src={gobiernoLogoSrc}
          alt="Gobierno Logo"
          loading="eager"
          decoding="async"
          sx={{
            display: "block",
            height: isCompactHeader ? "34px" : "41px",
            objectFit: "contain",
            width: isCompactHeader ? "136px" : "164px",
          }}
        />
      </Box>

      {isCompactHeader ? (
        <>
          <Box sx={{ alignItems: "center", display: "flex", gap: 1, ml: "auto" }}>
            {auth.validLoggin() && (
              <>
                <IconButton
                  onClick={() => navigate("/AdministrationPanel/Dashboard")}
                  sx={{ color: navColor, p: 0.5 }}
                >
                  <Box
                    component="img"
                    src={DashboardIcon}
                    alt="Dashboard"
                    sx={{ display: "block", height: "25px", width: "25px" }}
                  />
                </IconButton>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#761542",
                    color: "#FFFFFF",
                    borderRadius: "50%",
                    height: "28px",
                    width: "28px",
                    fontFamily: "Candara",
                    fontSize: "14px",
                    fontWeight: 700,
                  }}
                >
                  {userInitial}
                </Box>
              </>
            )}
            <IconButton
              edge="end"
              color="inherit"
              aria-label="menu"
              onClick={principalpageconfigs.toggleMenu}
              sx={{ color: navColor, p: "6px" }}
            >
              {principalpageconfigs.isMenuOpen ? (
                <CloseIcon sx={{ fontSize: "34px" }} />
              ) : (
                <MenuIcon sx={{ fontSize: "34px" }} />
              )}
            </IconButton>
          </Box>
        </>
      ) : (
        <>
          <Box
            component="nav"
            sx={{
              alignItems: "center",
              display: "flex",
              flex: 1,
              gap: "6px",
              justifyContent: "end",
              px: 1,
              py: 0,
            }}
          >
            <StyledLink
              to="/"
              variant="primary"
              style={{
                ...baseNavLinkStyle,
                backgroundColor: !isFaq && !isBlog ? "#761542" : "transparent",
                color: !isFaq && !isBlog ? "#FFFFFF" : navColor,
              }}
            >
              VISITAX Quintana Roo
            </StyledLink>
            <StyledLink
              to="/FAQS"
              variant="primary"
              style={{
                ...baseNavLinkStyle,
                backgroundColor: isFaq ? "#761542" : "transparent",
                color: isFaq ? "#FFFFFF" : navColor,
              }}
            >
             {selectedFlag === "us" ? "FAQs" : txt[194]}
            </StyledLink>
            <StyledLink
              to="/Blog"
              variant="primary"
              style={{
                ...baseNavLinkStyle,
                backgroundColor: isBlog ? "#761542" : "transparent",
                color: isBlog ? "#FFFFFF" : navColor,
              }}
            >
              {txt[195]}
            </StyledLink>
          </Box>

          <Box
            sx={{
              alignItems: "center",
              display: "flex",
              gap: "15px",
              justifyContent: "center",
              minWidth: "280px",
            }}
          >
            <Box
              sx={{
                alignItems: "center",
                display: "flex",
                gap: "5px",
                height: "32px",
                width: "168px",
              }}
            >
              <Box
                component="img"
                srcSet={`https://flagcdn.com/w80/${selectedFlag}.png 2x`}
                src={`https://flagcdn.com/w40/${selectedFlag}.png`}
                alt="Selected Language"
                sx={{
                  borderRadius: "24px",
                  display: "block",
                  height: "30px",
                  width: "56px",
                }}
              />
              <Box
                component="select"
                aria-label="Seleccionar idioma"
                value={configurations.currentlenguage}
                onChange={(event) =>
                  configurations.setLenguage(Number(event.target.value))
                }
                sx={{
                  appearance: "none",
                  background: "transparent",
                  border: "none",
                  color: navColor,
                  cursor: "pointer",
                  fontFamily: "Candara",
                  fontSize: "14px",
                  fontWeight: 600,
                  minWidth: "79px",
                  outline: "none",
                }}
              >
                {configurations.lenguageList.map((value, id) => (
                  <option key={id} value={id} style={{ color: "#1F1F1F" }}>
                    {value}
                  </option>
                ))}
              </Box>
              <KeyboardArrowDownRoundedIcon
                sx={{ color: navColor, fontSize: "25px", marginLeft: "-28px" }}
              />
            </Box>

            {!auth.validLoggin() ? (
              <StyledLink
                to="/Login"
                variant="btn"
                style={{
                  alignItems: "center",
                  border: isLight
                    ? "1.5px solid #761542"
                    : "1.5px solid #FFFFFF",
                  borderRadius: "25px",
                  color: navColor,
                  fontSize: "14px",
                  fontWeight: 600,
                  justifyContent: "center",
                  marginLeft: 0,
                  padding: "10px 24px",
                  textTransform: "none",
                  textAlign: "center",
                }}
              >
                {txt[60]}
              </StyledLink>
            ) : (
              <>
                <IconButton
                  onClick={() => navigate("/AdministrationPanel/Dashboard")}
                  sx={{ color: navColor, p: 0.5 }}
                >
                  <Box
                    component="img"
                    src={DashboardIcon}
                    alt="Dashboard"
                    sx={{ display: "block", height: "25px", width: "25px" }}
                  />
                </IconButton>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#761542",
                    color: "#FFFFFF",
                    borderRadius: "50%",
                    height: "32px",
                    width: "32px",
                  }}
                >
                  {userInitial}
                </Box>
                <IconButton
                  onClick={() => setOpenLogoutModal(true)}
                  sx={{ color: navColor, p: 0.5 }}
                >
                  <Box
                    component="img"
                    src={LogoutIcon}
                    alt="Logout"
                    sx={{ display: "block", height: "25px", width: "25px" }}
                  />
                </IconButton>
              </>
            )}
          </Box>
        </>
      )}

      <LogoutModal
        open={openLogoutModal}
        onClose={() => setOpenLogoutModal(false)}
      />
    </StyledToolbar>
  );
};

export default PrincipalPageToolBar;
